<template>
  <div class="loader-wrapper">
    <div class="loader">
      <div
        :style="`border: 3.2px solid ${borderColor}; border-color: ${borderColor} transparent transparent transparent; `"
      ></div>
      <div
        :style="`border: 3.2px solid ${borderColor}; border-color: ${borderColor} transparent transparent transparent; `"
      ></div>
      <div
        :style="`border: 3.2px solid ${borderColor}; border-color: ${borderColor} transparent transparent transparent; `"
      ></div>
      <div
        :style="`border: 3.2px solid ${borderColor}; border-color: ${borderColor} transparent transparent transparent; `"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    message: String,
    borderColor: String,
  },
};
</script>

<style scoped>
p {
  font-size: 0.8em;
  font-weight: 300;
  margin-top: 5px;
  letter-spacing: 1px;
  color: rgb(82, 82, 82);
}

.loader-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 2;
  cursor: pointer;
}

.loader {
  display: inline-block;
  position: relative;
  width: 16px;
  height: 16px;
}
.loader div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  animation: rotation 1s linear infinite;
}
.loader div:nth-child(1) {
  animation-delay: -0.45s;
}
.loader div:nth-child(2) {
  animation-delay: -0.3s;
}
.loader div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
